const ROW_HEIGHT = 'h-[40px]'
const ROW_HEIGHT_RIGHT = `${ROW_HEIGHT} text-right`

/**
 * Formatea valores porcentuales según los criterios:
 * - Usa coma (,) como separador decimal
 * - Muestra 0 antes de la coma para valores < 1%
 * - Mantiene el símbolo % al final
 */
const formatPercentage = (value) => {
  if (value === null || value === undefined || value === '') return ''

  // Convertir a string y reemplazar punto por coma
  let formatted = String(value).replace('.', ',')

  // Si comienza con coma, agregar 0 antes (ej: ,47% -> 0,47%)
  if (formatted.startsWith(',')) {
    formatted = '0' + formatted
  }

  // Asegurar que termine con %
  if (!formatted.endsWith('%')) {
    formatted += '%'
  }

  return formatted
}

export const TOP_DENUNCIAS_COLUMNS = [
  { key: 'cuil', label: 'CUIL', type: 'string', cellClassName: ROW_HEIGHT },
  { key: 'nombre', label: 'Apellido y nombre', type: 'string', cellClassName: ROW_HEIGHT },
  { key: 'cantidad', label: 'Denuncias', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'lugarTrabajo', label: 'Accidente de Trabajo', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'inItinere', label: 'In Itínere', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'efProf', label: 'Enfermedad profesional', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'juicios', label: 'Juicios', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'cantAutodenuncia', label: 'Autodenuncias', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'activo', label: 'Estado activo', type: 'string', cellClassName: ROW_HEIGHT_RIGHT },
]

export const SINIESTRALIDAD_COLUMNS = [
  { key: 'periodo', label: 'Período', type: 'string', cellClassName: ROW_HEIGHT },
  { key: 'empleados', label: 'Nómina', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'siniestrosLt', label: 'Stro AT', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'siniestrosIi', label: 'Stro IT', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'siniestrosEp', label: 'Stro EP', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'siniestros', label: 'Stro Total', type: 'number', cellClassName: ROW_HEIGHT_RIGHT },
  { key: 'incLt', label: 'Fr. AT', type: 'string', cellClassName: ROW_HEIGHT_RIGHT, formatter: formatPercentage },
  { key: 'incIi', label: 'Fr. IT', type: 'string', cellClassName: ROW_HEIGHT_RIGHT, formatter: formatPercentage },
  { key: 'incEp', label: 'Fr. EP', type: 'string', cellClassName: ROW_HEIGHT_RIGHT, formatter: formatPercentage },
  { key: 'incTotal', label: 'Fr. Total', type: 'string', cellClassName: ROW_HEIGHT_RIGHT, formatter: formatPercentage },
]
